import { notifications } from '~/app/notifications'
import AddToCart from '~/themes/base/components/cart/AddToCart'

const getNumericPrice = value => {
  const number = Number(value)

  return Number.isFinite(number) ? number : 0
}

const getItemUnitWithTax = item => {
  if (!item) {
    return 0
  }

  const unitWithTax = getNumericPrice(item.prices?.unitWithTax)

  if (unitWithTax > 0) {
    return unitWithTax
  }

  const totalWithTax = getNumericPrice(item.prices?.totalWithTax)

  if (totalWithTax > 0) {
    const amount = getNumericPrice(item.amount) || 1

    return totalWithTax / amount
  }

  return (item.items || []).reduce((sum, child) => sum + getItemUnitWithTax(child), 0)
}

const getSelectedVariant = (product, variant, variantId) => {
  return variant || (product?.variants || []).find(item => item.id === variantId) || product
}

const addVariantPriceFallback = (item, variant, product, quantity) => {
  if (getItemUnitWithTax(item) > 0) {
    return item
  }

  const selectedVariant = getSelectedVariant(product, variant, item?.variantId || item?.variant?.id)
  const prices = selectedVariant?.prices || {}
  const unitWithTax = getNumericPrice(prices.unitWithTax)
  const unitWithoutTax = getNumericPrice(prices.unitWithoutTax)

  if (unitWithTax <= 0 && unitWithoutTax <= 0) {
    return item
  }

  const amount = getNumericPrice(item?.amount) || getNumericPrice(quantity) || 1

  return {
    ...item,
    prices: {
      ...(item?.prices || {}),
      unitWithTax,
      unitWithoutTax,
      totalWithTax: unitWithTax * amount,
      totalWithoutTax: unitWithoutTax * amount,
    },
  }
}

export default {
  extends: AddToCart,
  methods: {
    getPreparedCustomData() {
      if (!this.addToCartCustomData || typeof this.addToCartCustomData !== 'object') {
        return this.addToCartCustomData
      }

      const customData = { ...this.addToCartCustomData }
      const resolvedExternalId =
        this.variant?.externalId || this.product?.externalId || this.variant?.productId || this.product?.productId

      if (customData.width != null && customData.height != null && !customData.externalId && resolvedExternalId) {
        customData.externalId = resolvedExternalId
      }

      return customData
    },
    async addToCart(variantId) {
      if (this.$store.state.globals.cartConfiguration.shopping_disabled) {
        notifications.warning(this.$store.state.globals.cartConfiguration.shopping_disabled_text)
        return
      }

      if (this.disabled) {
        notifications.danger(this.$t('AddToCart.variantDoesNotExist'))
        return
      }

      this.startLoading()
      const customData = this.getPreparedCustomData()
      const data = await this.$store.dispatch('cart/ADD_TO_CART', {
        id: variantId,
        quantity: this.quantity,
        forCredits: this.forCredits,
        ...(customData ? { custom: customData } : {}),
        ...(this.addToCartNewLine ? { newLine: this.addToCartNewLine } : {}),
      })
      if (data && data.addedItem) {
        this.addedItem = addVariantPriceFallback(data.addedItem, this.variant, this.product, this.quantity)
        this.changedAmount = data.changedAmount
        this.$refs.addToCartModalChooseVariant && this.$refs.addToCartModalChooseVariant.hide()
        this.$store.dispatch('cart/FETCH_AVAILABLE_GIFTS')
        this.openAddToCartModalItemAdded()
      }
      this.stopLoading()
    },
  },
}
